import { render, staticRenderFns } from "./ComponentList.vue?vue&type=template&id=401b6c8d"
import script from "./ComponentList.vue?vue&type=script&lang=js"
export * from "./ComponentList.vue?vue&type=script&lang=js"
import style0 from "./ComponentList.vue?vue&type=style&index=0&id=401b6c8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports